export class QuarantineViolationsProcess {
  public contractId: number;
  public violationIds: Array<number>;
  public reasonId: number;
}
